import { PatientService } from '@/services/patient.service';
import { TABS } from '@/constants/patient';
export default {
  props: {
    tab: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {
      showDialog: false,
      alert: {
        show: false,
        message: ''
      },
      selectedTab: this.tab,
      minimum: '',
      maximum: ''
    };
  },
  computed: {
    tabOptions() {
      return TABS.flatMap(x => x.tabs).map(x => {
        return {
          value: x.id,
          text: x.text
        };
      });
    }
  },
  watch: {
    showDialog(show) {
      this.alert.message = '';
      this.alert.show = false;
      if (show) {
        this.selectedTab = this.tab;
      } else {
        this.minimum = '';
        this.maximum = '';
      }
    }
  },
  methods: {
    async exportData() {
      this.alert.show = false;
      const min = Number(this.minimum);
      const max = Number(this.maximum);
      if (min && max && min > max) {
        this.alert.show = true;
        this.alert.message = 'The minimum cannot be greater than the maximum.';
        return;
      }
      const {
        data: url
      } = await PatientService.exportRecords(this.selectedTab, this.minimum, this.maximum);
      if (!url) {
        return;
      }
      const newWindow = window.open(url, '_blank');
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        console.error('Pop-up blocked or failed to open');
      }
    }
  }
};